import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';


const Capabilities = () => {

  return (
    <>
    <Navbar/>
  <h1>Welcome! Capabilities</h1>
    <Footer/>
    </>
  )
}
export default Capabilities;
